<template>
    <div class="menuContainerv2" role="navigation">
        <div class="pandoraMenuv2">
            <MenuItem @click="item.action? item.action(): undefined" :text="item.title" :submenu="item?.submenu" v-for="(item, index) in props.menuitems" :key="`menu-${index}`" :titleactive="props.titleactive">
            <div class="pandoraMenuv2" v-if="item.submenu">
                <MenuItem style="z-index: 10000 !important;" @click="item2.action? item2.action(): undefined" :text="item2.title" :submenu="item2?.submenu" v-for="(item2, index2) in item.submenu" :key="`menu2-${index2}`">
                <div class="pandoraMenuv2" v-if="item2.submenu">
                    <MenuItem style="z-index: 10000 !important;" @click="item3.action? item3.action(): undefined" :text="item3.title" :submenu="item3?.submenu" v-for="(item3, index3) in item2.submenu" :key="`menu3-${index3}`">
                    <div class="pandoraMenuv2" v-if="item3.submenu">
                        <MenuItem style="z-index: 10000 !important;" @click="item4.action? item4.action(): undefined" :text="item4.title" :submenu="item4?.submenu" v-for="(item4, index4) in item3.submenu" :key="`menu4-${index4}`">
                        </MenuItem>
                    </div>
                    </MenuItem>
                </div>
                </MenuItem>
            </div>
            </MenuItem>
        </div>
    </div>
</template>

<script setup>
import MenuItem from '../menuItem/MenuItemv2.vue';

import { defineProps } from 'vue';

const props = defineProps({
    titleactive: {
        type: String,
        default: ''
    },
    menuitems: {
        default: []
    }
});
</script>

<style scoped>
body * {
    margin: 0;
    padding: 0;
}

.menuContainerv2>.pandoraMenuv2 {
    display: ruby;
}

.menuContainerv2 .pandoraMenuitemv2>.pandoraMenuv2 {
    position: absolute;
    pointer-events: none;
}

.pandoraMenuitemv2:hover>.pandoraMenuv2 {
    pointer-events: initial;
}

.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2 .pandoraMenuitemv2 .pandoraMenuv2 {
    transform: translateX(100%);
    top: 0;
    right: 0;
}
</style>